import * as React from 'react';
import { CardMedia, PaletteMode } from '@mui/material';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink } from 'react-router-dom';
import { ButtonBrand } from '../../../getLPTheme';

const logoStyle = {
  width: '50px',
  height: 'auto',
  cursor: 'pointer',
};

interface AppAppBarProps {
  mode: PaletteMode;
  toggleColorMode: () => void;
}

function AppAppBar({ mode, toggleColorMode }: AppAppBarProps) {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({
        top: targetScroll,
        behavior: 'smooth',
      });
      setOpen(false);
    }
  };

  return (
      <AppBar position="fixed" sx={{boxShadow: 0,bgcolor: 'transparent',backgroundImage: 'none',mt: 0,}}>
          <Toolbar
            variant="regular"
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexShrink: 0,
              borderRadius: '999px',
              bgcolor:
                theme.palette.mode === 'light'
                  ? 'rgba(255, 255, 255, 0.4)'
                  : 'rgba(0, 0, 0, 0.4)',
              backdropFilter: 'blur(24px)',
              maxHeight: 40,
              border: '1px solid',
              borderColor: 'divider',
              boxShadow:
                theme.palette.mode === 'light'
                  ? `0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)`
                  : '0 0 1px rgba(2, 31, 59, 0.7), 1px 1.5px 2px -1px rgba(2, 31, 59, 0.65), 4px 4px 12px -2.5px rgba(2, 31, 59, 0.65)',
            })}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                ml: '-18px',
                px: 0,
              }}
            >
              <Box sx={{px:0}}>
                <MenuItem onClick={() => scrollToSection('banner')} >
                  <CardMedia  component='img' image={"images/logoWorldWhite.png"} sx={{width: 60, height: 50}}/>
                </MenuItem>
              </Box>
              <Box sx={{}}>
                <CardMedia onClick={() => scrollToSection('banner')} component='img' image={"images/logoWorldGolfClubWhite.png"} sx={{width: 160, height: 55}}/>
              </Box>

              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                {/* <MenuItem onClick={() => scrollToSection('aboutUs')} sx={{ py: '6px', px: '12px' }}>
                  <Typography variant="body2" color="text.primary">
                    SOBRE NOSOTROS
                  </Typography>
                </MenuItem>
                <MenuItem onClick={() => scrollToSection('beneficios')} sx={{ py: '6px', px: '12px' }}>
                  <Typography variant="body2" color="text.primary">
                    BENEFICIOS
                  </Typography>
                </MenuItem> */}

                <RouterLink to={"/contact"} style={{ textDecoration: 'none' }}>
                  {/* <MenuItem sx={{ pl:1, py: '6px', px: '12px' }}> */}
                  <Button variant="outlined" sx={{ml: 5}}>
                    <Typography variant="body2" color="text.primary">
                      PARA EMPRESAS
                    </Typography>
                  </Button>
                  {/* </MenuItem> */}
                </RouterLink>
              </Box>
            </Box>
            <Box
              sx={{
                display: { xs: 'none', md: 'flex' },
                gap: 0.5,
                alignItems: 'center',
              }}
            >
              <RouterLink to={"/login"}>
                <ButtonBrand 
                  size="small"
                >
                  Iniciar Sesion
                </ButtonBrand>
              </RouterLink>
              <RouterLink to={"/registrarse"}>
                <ButtonBrand
                  size="small"
                >
                  Registrarse
                </ButtonBrand>
              </RouterLink>
            </Box>
              {/* Si es pantalla chica se habilita el menu deplegable: */}
            <Box sx={{ display: { sm: '', md: 'none' } }}>
              <Button
                variant="text"
                color="primary"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ minWidth: '30px', p: '4px' }}
              >
                <MenuIcon />
              </Button>
              <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <Box
                  sx={{
                    minWidth: '60dvw',
                    p: 2,
                    backgroundColor: 'background.paper',
                    flexGrow: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'end',
                      flexGrow: 1,
                    }}
                  >
                  
                  </Box>
                  {/* <MenuItem onClick={() => scrollToSection('aboutUs')}>
                    SOBRE NOSOTROS
                  </MenuItem>
                  <MenuItem onClick={() => scrollToSection('beneficios')}>
                    BENEFICIO
                  </MenuItem> */}
                  <RouterLink to={"/contact"} style={{ textDecoration: 'none' }}>
                    <Button variant="outlined">
                    <Typography variant="body2" color="text.primary">
                      PARA EMPRESAS
                    </Typography>  
                    </Button>
                  </RouterLink>
                    <Box sx={{pt:2, display: "flex"}}>
                      <MenuItem>
                      <RouterLink to={"/login"}>
                        <ButtonBrand
                          sx={{ width: '100%' }}
                        >
                          Iniciar Sesion
                        </ButtonBrand>
                      </RouterLink>
                      </MenuItem>
                      <MenuItem>
                      <RouterLink to={"/registrarse"}>
                        <ButtonBrand
                          sx={{ width: '100%' }}
                        >
                          Registrarse
                        </ButtonBrand>
                      </RouterLink>
                      </MenuItem>
                    </Box>
                </Box>
              </Drawer>
            </Box>
          </Toolbar>
      </AppBar>
  );
}

export default AppAppBar;
